export const ROLE_TYPES = {
	ER_USER: "ER_USER",
	ER_CLIENT: "ER_CLIENT",
	ER_REVIEWER: "ER_REVIEWER",
	ER_VERIFIER: "ER_VERIFIER",
	ER_SUPERADMIN: "ER_SUPERADMIN",
	ER_ADMIN: "ER_ADMIN",
	ER_PORTCODEADMIN: "ER_PORTCODEADMIN",
	ER_ABSTESTER: "ER_ABSTESTER",
};
